// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"13":"0c428ae2","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"13":"0951be126f1e6dc75624","678":"b707bb7e439bd20ceb04","883":"f5d15e81247ce7569ae2"}[chunkId] + ".js";
};